module.exports = __webpack_public_path__ + "static/media/record.cf0695d1.png";